/*
 * Module for handling the list of reports in the report page.
 * This is basically the same as the list for sub groups.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/reportSplit/groups/groupList/groupListView",
  "modules/reportSplit/reports/reportModel",
], function (Marionette, Messenger, GroupListView, ReportModel) {
  var GroupListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reportGroupListModule";
      this.region = options.region;
      this.selectedModel = null;
    },
    show: function (groups) {
      this.topicReportGroupName = "reports.groups.topic";
      this.topicResponseStatusReportName = "reports.topicResponseStatus.name";
      this.groups = groups;
      this._setUpView(this.groups);
      this.showRegion(this.view, { loading: true });
    },
    _setUpView: function (groups) {
      this.view = new GroupListView.reportList({ collection: groups });
      this.view.on(
        "itemview:click:reportGroup",
        function (clickedView) {
          this._selectGroup(clickedView);
        },
        this,
      );

      //when the groups list is loaded (but after the view has been shown), make sure to select the first one
      this.view.on(
        "show",
        function () {
          groups.onSynced(function () {
            //remove topic response status report
            var report = this._findTopicResponseStatusReport();
            this._deleteReportInGroup(this.topicReportGroupName, report);
            //find the child view represented by the first model
            if (groups.length > 0) {
              var childView = this.view.children.findByModel(groups.at(0));
              this._selectGroup(childView); //this will visually select the group, as well as trigger the group being show by groupTilesModule
            }
          }, this);
        },
        this,
      );

      return this.view;
    },
    _findTopicResponseStatusReport: function () {
      var reportModel = null;
      var foundReport = false;
      this.groups.each(function (group) {
        if (!foundReport && group.get("name") === this.topicReportGroupName) {
          var topicReportModels = group.get("reports");
          reportModel = this._getReportModelByName(
            this.topicResponseStatusReportName,
            topicReportModels,
          );
          foundReport = true;
        }
      }, this);
      return reportModel;
    },
    _getReportModelByName: function (name, reports) {
      var report_name = name;
      var reportToReturn;
      reports.each(function (report) {
        if (report.get("name") === report_name) {
          reportToReturn = report;
        }
      }, this);
      return reportToReturn;
    },
    _deleteReportInGroup: function (groupName, reportToDelete) {
      var groupThatHasTheReport;
      var name = groupName;
      this.groups.each(function (group) {
        if (group.get("name") === name) {
          groupThatHasTheReport = group;
        }
      }, this);
      groupThatHasTheReport.get("reports").remove(reportToDelete);
    },
    _markAsSelected: function () {
      var view = this.view.children.findByModel(this.selectedModel);
      if (view) {
        view.$el.addClass("active"); //apply 'selected' class
      }
    },
    _markAsUnselected: function () {
      var view = this.view.children.findByModel(this.selectedModel);
      if (view) {
        view.$el.removeClass("active"); //remove 'selected' class
      }
    },
    _selectGroup: function (clickedView) {
      var selectedModel = clickedView.model;
      if (this.selectedModel !== null) {
        this._markAsUnselected(); //unselect current group
        this._handleSelectGroup(selectedModel);
      } else {
        this._handleSelectGroup(selectedModel);
      }
    },
    _handleSelectGroup: function (clickedModel) {
      this.selectedModel = clickedModel;
      this._markAsSelected();
      // When the user selects Ad-Hoc Reports, hide the report tiles and show the list of workbooks instead
      if (clickedModel.get("name") === "reports.groups.adHoc") {
        Messenger.vent.trigger("hide:report:tiles");
        Messenger.vent.trigger("show:adHoc:workbooks", clickedModel);
      } else {
        Messenger.vent.trigger("show:report:tiles");
        Messenger.vent.trigger("show:reportGroup", clickedModel);
      }
    },
  });

  return GroupListController;
});
